<template>
  <div class="date-select">
    <div
      class="date-select__wrapper"
      v-if="!yearOnly"
    >
      <select
        name="quarter"
        v-model="quarter"
        @change="setQuarter($event.target.value)"
      >
        <option
          :key="`quarter-${quarter}`"
          v-for="(quarter, index) in quarters"
          :value="index + 1"
        >
          {{ quarter }}
        </option>
      </select>
      <ag-icon
        class="date-select__icon"
        name="chevron-right" />
    </div>
    <div
      v-if="availableYears && availableYears.length > 0"
      class="date-select__wrapper"
      :class="{ 'date-select__wrapper--standalone': yearOnly}"
    >
      <select
        name="year"
        v-model="year"
        @change="setYear($event.target.value)"
      >
        <option
          :key="`year-${year}`"
          v-for="year in availableYears"
          :value="year"
        >
          {{ year }}
        </option>
      </select>
      <ag-icon
        class="date-select__icon"
        name="chevron-right" />
    </div>
  </div>
</template>

<script>
import AgIcon from '@/components/shared/AgIcon.vue';

export default {
  name: 'AgDateSelect',
  components: {
    AgIcon,
  },
  props: {
    yearOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    availableYears: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      year: (() => {
        const year = new Date().getFullYear();
        const month = new Date().getMonth() + 1;
        switch (month) {
          case 1:
            return year - 1;
          default:
            return year;
        }
      })(),
      years: (() => {
        const x = [];
        for (let i = new Date().getFullYear(), l = 2017; i >= l; i -= 1) {
          x.push(i);
        }
        return x;
      })(),
      quarter: (() => {
        const month = new Date().getMonth() + 1;
        switch (month) {
          case 1:
            return 4;
          case 4:
            return 1;
          case 7:
            return 2;
          case 10:
            return 3;
          default:
            return (Math.ceil(month / 3));
        }
      })(),
      quarters: [
        '1. Quartal',
        '2. Quartal',
        '3. Quartal',
        '4. Quartal',
      ],
    };
  },
  mounted() {
    this.setQuarter();
  },
  methods: {
    setYear() {
      this.$emit('yearSelected', this.year);
    },
    setQuarter() {
      this.$emit('quarterSelected', this.quarter);
    },
  },
};
</script>

<style lang="scss">

.date-select {

  &__wrapper {
    $font-size: 16px;
    font-size: rem($font-size);
    display: inline-block;
    position: relative;
    width: 49%; //has to be done like this for ie11 issues
    margin-right: em(10px, $font-size);

    @include mq($mq-large) {
      $font-size: 16px;
      font-size: rem($font-size);
      width: auto;
      margin-right: em(15px, $font-size);
    }

    &--standalone {
      width: rem(100px);

      @include mq($mq-large) {
        width: auto;
      }
    }

    &:last-of-type {
      margin-right: 0;
    }

    & > select {
      $font-size: 16px;
      font-size: rem($font-size);
      background-color: $bg-light-color;
      font-weight: 600;
      width: 100%;
      color: $primary-color;
      padding: em(5px, $font-size);
      outline: none;
      cursor: pointer;
      border: 1.5px solid rgba(123, 142, 169, 0.3);
      appearance: none;
      -ms-appearance: none;
      -moz-appearance: none;
      -webkit-appearance: none;

      @include mq($mq-large) {
        $font-size: 16px;
        font-size: rem($font-size);
        width: em(170px, $font-size);
        padding: em(10px, $font-size);
      }

      &:active,
      &:focus {
        border-color: $brand-color;
      }
    }
  }

  &__icon {
    $font-size: 16px;
    font-size: rem($font-size);
    color: $primary-color;
    position: absolute;
    height: em(12px, $font-size);
    width: em(12px, $font-size);
    transform: rotate(90deg);
    top: em(12px, $font-size);
    right: em(12px, $font-size);

    @include mq($mq-large) {
      $font-size: 16px;
      font-size: rem($font-size);
      top: em(18px, $font-size);
    }
  }
}

</style>
